import { NgModule } from "@angular/core";
import { MomentTimezonePipe } from "../../../pipe/moment-timezone.pipe";

@NgModule({
    imports: [],
    exports: [MomentTimezonePipe],
    declarations: [MomentTimezonePipe],
})
export class MomentTimezonePipeModule {}
